import React from "react";

function LiveProductionPage(props: any) {
  return <div className="body-container">Live production page</div>;
}

export default LiveProductionPage;
